/**
 * A sample MOGZO challenge, built around the game: which game and level, who sent it, the
 * score to beat and how many players tried. Decorative, so nothing in it is interactive.
 * Game preview art from the Figma "In product" frame (1:95).
 */
export function ChallengePreview() {
  return (
    <figure
      aria-label="Example MOGZO challenge: pixelfox challenges you to beat 41.8 seconds on level 7 of Sky Hopper"
      className="w-full max-w-[520px] rounded-2xl border border-line bg-card p-3 shadow-[0_12px_40px_-12px_rgba(27,21,47,0.25)]"
    >
      <div aria-hidden="true">
        <div className="flex items-center gap-3 px-1 pt-1">
          <span className="flex size-10 shrink-0 items-center justify-center rounded-xl bg-ink">
            <img src="/brand/player.svg" alt="" width={20} height={20} />
          </span>
          <span className="min-w-0">
            <span className="block text-sm leading-tight font-bold text-ink">Sky Hopper</span>
            <span className="block text-xs text-muted">Level 7 · Platformer</span>
          </span>
          <span className="ml-auto rounded-full bg-brand px-3 py-1 text-[11px] font-bold text-ink">
            Challenge
          </span>
        </div>

        <div className="mt-3 flex items-center gap-2 px-1">
          <span className="flex size-6 items-center justify-center rounded-full bg-avatar text-[9px] font-bold text-ink">
            PF
          </span>
          <span className="text-xs text-muted">
            <span className="font-bold text-ink">pixelfox</span> challenged you · 2h ago
          </span>
        </div>
        <p className="px-1 pt-1.5 pb-3 text-lg font-bold text-ink">Beat my 41.8s run on level 7</p>

        <div className="relative aspect-[502/225] overflow-hidden rounded-xl bg-ink">
          <span className="absolute top-[7%] left-[3%] rounded-full bg-ink-soft px-2.5 py-1 font-mono text-[10px] text-white">
            Time to beat <span className="text-brand">41.8s</span>
          </span>
          <img
            src="/brand/coin.svg"
            alt=""
            width={18}
            height={18}
            className="absolute top-[21%] left-[87%]"
          />
          <span className="absolute top-[34%] left-[69%] h-[6%] w-[24%] rounded-full bg-plum" />
          <span className="absolute top-[50%] left-[40%] h-[6%] w-[21%] rounded-full bg-plum" />
          <span className="absolute top-[67%] left-[6%] h-[6%] w-[27%] rounded-full bg-plum" />
          <img
            src="/brand/player.svg"
            alt=""
            width={30.5}
            height={30}
            className="absolute top-[52%] left-[14.5%]"
          />
          <span className="absolute top-[74%] left-[40.6%] inline-flex items-center gap-2 rounded-full bg-brand px-5 py-2.5 text-sm font-bold text-ink">
            <img src="/brand/play.svg" alt="" width={9} height={10} />
            Play
          </span>
        </div>

        <div className="flex flex-wrap items-center gap-3 px-1 pt-3 pb-1">
          <dl className="flex gap-5 text-xs">
            <div>
              <dt className="text-muted">Tried it</dt>
              <dd className="font-mono font-medium text-ink">128 players</dd>
            </div>
            <div>
              <dt className="text-muted">Beat it</dt>
              <dd className="font-mono font-medium text-ink">9</dd>
            </div>
          </dl>
          <span className="ml-auto rounded-full bg-ink px-4 py-2 text-xs font-bold text-white">
            Accept challenge
          </span>
        </div>
      </div>
    </figure>
  );
}
